export default "__VITE_ASSET__ac50dd94__"